const unslugify = slug => {
  if (!slug) return ""
  return slug
    .split("-")
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ")
}

// converts 10000000 into 10M
const readableNumber = count => {
  const mil = 1000000
  const thou = 1000

  if (count >= mil) {
    return `${(count / mil).toFixed(1)}M`
  } else if (count >= thou) {
    return `${(count / thou).toFixed(0)}K`
  }
  return count
}

const capitalizeFirst = word => {
  if (!word) return ""
  return word[0].toUpperCase() + word.slice(1, word.length)
}

/** 1 -> "1st", 2 -> "2nd", 11 -> "11th" */
const ordinalWord = n => {
  const num = Number(n)
  if (!Number.isFinite(num)) return String(n)
  const mod100 = num % 100
  if (mod100 >= 11 && mod100 <= 13) return `${num}th`
  switch (num % 10) {
    case 1:
      return `${num}st`
    case 2:
      return `${num}nd`
    case 3:
      return `${num}rd`
    default:
      return `${num}th`
  }
}

const convertToSlug = t =>
  t
    .toLowerCase()
    .replace(/ /g, "-")
    .replace(/[^\w-]+/g, "")

/** Keeps strings within maxLength; cuts at the last space before the limit and appends ellipsis when truncated. */
const truncateAtWord = (text, maxLength, ellipsis = "...") => {
  if (text == null || text === "") {
    return ""
  }
  const s = String(text)
  if (s.length <= maxLength) {
    return s
  }
  const suffix = ellipsis || ""
  const limit = maxLength - suffix.length
  if (limit <= 0) {
    return suffix.slice(0, maxLength)
  }
  let chunk = s.slice(0, limit)
  const lastSpace = chunk.lastIndexOf(" ")
  if (lastSpace > 0) {
    chunk = chunk.slice(0, lastSpace)
  }
  chunk = chunk.replace(/\s+$/, "")
  return chunk + suffix
}

export {
  unslugify,
  readableNumber,
  capitalizeFirst,
  convertToSlug,
  ordinalWord,
  truncateAtWord,
}
